module.exports = __webpack_public_path__ + "static/media/Mobile-login-pana.7d163a5d.png";